import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';

interface RequireAuthProps {
  children: ReactNode;
}

/**
 * Guard de autenticación basado en el `authStore`. Si no hay token,
 * redirige a `/login`. El backend sigue siendo la autoridad — este guard
 * es UX, no seguridad.
 */
export function RequireAuth({ children }: RequireAuthProps) {
  const token = useAuthStore((s) => s.token);
  if (token === null) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}
